import { createContext } from 'react';

const ConfirmSwitchCompanyContext = createContext({ openDialog: (companyId, onSwitchComplete = (companyId) => {}) => {} });

export default ConfirmSwitchCompanyContext;
